export const MUI_BOTTOM_BAR_HEIGHT = 56

export const DRAWER_WIDTH_PX = 256

export const HEADER_HEIGHT_PX = 64
export const HEADER_HEIGHT_MOBILE_PX = 48

export const installationFormHeaderHeightSmall = 50
export const installationFormHeaderHeightMedium = 70

export const MAXIMUM_EVSES_PER_INSTALLATION = 8
export const MAXIMUM_METERS_PER_INSTALLATION = 7
export const MAX_TOTAL_POWER_CONSUMPTION = 2147483647

export const MAX_Nominal_POWER = 23_000

export const MAX_NUMBER_OF_SECURITY_TEMPERATURE = 4
export const MAX_MY_PV_TEMPERATURE_CELSIUS = 90

export const MAP_HEIGHT_PX = 400

export const PV_METER_MIN_PEAK_POWER = 2
export const PV_METER_MAX_PEAK_POWER = 2_000_000

export const MOBILE_HEADER_TRANSITION = 'top 0.3s'

export const installationPaths = {
  General: 'general',
  Storage: 'storage',
  Evse: 'charging-stations',
  Hvac: 'heatpump',
  Meters: 'meters',
  Io: 'io-interfaces',
} as const

export type InstallationPath = (typeof installationPaths)[keyof typeof installationPaths]
